// src/components/TarotCard.jsx
import React from 'react';

const TarotCard = ({ card, isFlipped, onFlip, showLabel = false }) => (
  <div className="tarot-card-wrapper" onClick={onFlip}>
    <div className={`tarot-card-inner ${isFlipped ? 'is-flipped' : ''}`}>
      {/* Reverso de la carta */}
      <div className="tarot-card-face tarot-card-back">
        <div className="card-back-pattern">
          <svg viewBox="0 0 100 100" className="card-back-svg" aria-hidden="true">
            <defs>
              <radialGradient id="cardGrad" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#a78bfa" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#4f46e5" stopOpacity="0.0" />
              </radialGradient>
            </defs>
            <circle cx="50" cy="50" r="45" fill="url(#cardGrad)" stroke="#a78bfa" strokeWidth="0.5" />
            <circle cx="50" cy="50" r="30" fill="none" stroke="#c4b5fd" strokeWidth="0.3" />
            <polygon points="50,15 61,40 88,40 66,57 74,82 50,65 26,82 34,57 12,40 39,40"
              fill="none" stroke="#c4b5fd" strokeWidth="0.4" opacity="0.7" />
          </svg>
        </div>
      </div>

      {/* Frente de la carta */}
      <div className="tarot-card-face tarot-card-front">
        {card ? (
          <>
            {card.isReversed ? (
              <img
                src={card.image}
                alt={card.name}
                className="tarot-card-img tarot-card-img--reversed"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://placehold.co/300x530/1e1b4b/d8b4fe?text=🔮';
                }}
              />
            ) : (
              <img
                src={card.image}
                alt={card.name}
                className="tarot-card-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://placehold.co/300x530/1e1b4b/d8b4fe?text=🔮';
                }}
              />
            )}
            {card.isReversed && (
              <div className="reversed-badge">↕ Invertida</div>
            )}
          </>
        ) : null}
      </div>
    </div>

    {showLabel && card && (
      <p className="tarot-card-label">{card.name}</p>
    )}
  </div>
);

export default TarotCard;
